export const inventoryV2 = {
	categoryMultiSelect: {
		addAll: "Adicionar todos",
		removeAll: "Remover todos",
	},
	tabs: {
		storages: "Estoques",
		inventories: "Inventários",
	},
	statuses: {
		open: "Aberto",
		in_review: "Aguardando aprovação",
		approved: "Concluído",
		reopened: "Reaberto",
	},
	inventoryHeader: {
		storage: "Estoque",
		stockist: "Estoquista",
		createdAt: "Criado em",
		updatedAt: "Última atualização",
		reopenReasonLabel: "Justificativa da reprovação",
	},
	byStorage: {
		actions: {
			createInventory: "Inventariar estoque",
		},
		bigNumbers: {
			total: "Inventários criados",
			approved: "Inventários fechados",
			open: "Inventários em aberto",
			inReview: "Inventários para aprovar",
			errorMessage: "Não foi possível carregar os totalizadores.",
		},
		filters: {
			keywordPlaceholder: "Buscar por nome do inventário",
			period: "Período",
			allStatuses: "Todos os status",
			categoriesPlaceholder: "Categorias",
			clear: "Limpar filtros",
		},
		table: {
			columns: {
				status: "Status",
				name: "Inventário",
				categories: "Categorias",
				worker: "Estoquista",
				updatedAt: "Última edição",
				actions: "Ações",
			},
			categoriesCount_one: "{{count}} categoria",
			categoriesCount_other: "{{count}} categorias",
			rowActions: {
				view: "Visualizar",
				continue: "Continuar",
				awaiting: "Aguardando",
				rejected: "Recusado",
				edit: "Editar",
				delete: "Excluir",
				menu: "Abrir menu de ações",
			},
			empty: {
				title: "Nenhum inventário neste estoque",
				description: "Comece um inventário para acompanhar este estoque.",
				action: "Inventariar estoque",
			},
		},
	},
	createInventoryDrawer: {
		titleCreate: "Inventariar estoque",
		titleEdit: "Editar inventário",
		fields: {
			name: {
				label: "Nome do inventário",
				placeholder: "Ex.: Mensal Maio",
				requiredError: "Informe o nome do inventário",
				maxLengthError:
					"O nome do inventário deve ter no máximo {{maxLength}} caracteres",
			},
			categoriesIds: {
				label: "Categorias",
				placeholder: "Selecione as categorias",
				requiredError: "Selecione pelo menos uma categoria",
			},
			storage: {
				label: "Estoque",
				placeholder: "Selecione um estoque",
				requiredError: "Selecione um estoque",
			},
			stockistName: {
				label: "Estoquista",
			},
		},
		buttons: {
			cancel: "Cancelar",
			create: "Iniciar contagem",
			save: "Salvar alterações",
		},
	},
	list: {
		filters: {
			storagesPlaceholder: "Todos os estoques",
		},
		table: {
			columns: {
				storage: "Estoque",
			},
			empty: {
				title: "Nenhum inventário encontrado",
				description: "Não encontramos inventários para os estoques deste local.",
			},
		},
	},
	inventoryCount: {
		header: {
			name: "Nome",
			status: "Status",
			storage: "Estoque",
			stockist: "Estoquista",
			createdAt: "Criado em",
			updatedAt: "Última atualização",
			editButton: "Editar",
			editApprovedTooltip: "Inventário concluído não pode ser editado.",
		},
		filters: {
			productNamePlaceholder: "Buscar produto",
			categoriesPlaceholder: "Todas as categorias",
			clear: "Limpar",
		},
		actions: {
			saveDraft: "Salvar rascunho",
			delete: "Deletar",
			deleteApprovedTooltip: "Inventário concluído não pode ser deletado.",
			cancel: "Cancelar",
			saveSuccess: "Rascunho salvo.",
			saveError: "Não foi possível salvar o rascunho.",
			deleteSuccess: "Inventário deletado.",
			deleteError: "Não foi possível deletar o inventário.",
		},
		accordion: {
			itemsSubtitle: "{{total}} itens",
			counterBadge: "{{inventoried}}/{{total}} itens inventariados",
		},
		productRow: {
			imageAlt: "Imagem do produto",
			columns: {
				product: "Produto",
				count: "Contagem",
				newCount: "Nova contagem",
				unit: "Unidade",
			},
			units: {
				milliliter: "Mililitros",
				liter: "Litros",
				kilogram: "Quilogramas",
				gram: "Gramas",
				unit: "Unidade",
			},
			unitRemainder: {
				add: "adicionar quantidade em {{units}}",
				remove: "remover quantidade em {{units}}",
				unitSuffix: "Unidades",
				tooltip:
					"Informe a quantidade restante (frações) além das unidades inteiras contadas",
			},
		},
		productRowAdmin: {
			columns: {
				systemCount: "Qtd no sistema",
				adjustment: "Ajuste",
				loss: "Perda",
				differenceQty: "Diferença em qtd",
				differenceValue: "Diferença em R$",
			},
		},
		submit: {
			stockist: {
				button: "Enviar para aprovação",
				dialogTitle: "Enviar para aprovação",
				dialogBody:
					"A contagem será enviada para aprovação e ficará aguardando revisão. Deseja continuar?",
				confirm: "Enviar",
				cancel: "Cancelar",
				success: "Inventário enviado para aprovação.",
				error: "Não foi possível enviar o inventário.",
			},
			admin: {
				button: "Concluir inventário",
				dialogTitle: "Concluir inventário",
				dialogBody:
					"Ao concluir, a contagem será aplicada às quantidades em estoque. Esta ação não pode ser desfeita. Deseja continuar?",
				confirm: "Concluir",
				cancel: "Cancelar",
				success: "Inventário concluído.",
				error: "Não foi possível concluir o inventário.",
			},
		},
		loading: "Carregando...",
		error: {
			title: "Erro ao carregar o inventário",
			body: "Tente novamente em instantes.",
			backToInventories: "Voltar para inventários",
		},
		permissions: {
			noAccess: "Você não tem permissão para acessar esta página.",
		},
		backToStorage: "Voltar para estoque",
		itemsHeader: "Itens do estoque",
	},
	inventoryApproval: {
		loading: "Carregando...",
		actions: {
			approve: "Aprovar inventário",
			reject: "Reprovar",
			exportPdf: "Exportar PDF",
		},
		bigNumbers: {
			positiveLabel: "Somatório de diferenças positivas",
			negativeLabel: "Somatório de diferenças negativas",
			productsCount_one: "{{count}} produto",
			productsCount_other: "{{count}} produtos",
			tooltip:
				"Quantidade de produtos com diferença e a soma do valor dessas diferenças (diferença × custo médio unitário).",
		},
		filters: {
			productNamePlaceholder: "Buscar por produto",
			categoriesPlaceholder: "Todas as categorias",
		},
		accordion: {
			itemsSubtitle: "{{total}} itens",
			counterBadge: "{{inventoried}}/{{total}} itens inventariados",
			inventoried: {
				title: "Itens inventariados",
				description:
					"Todos os itens que sofreram recontagem. Ajuste se foi perda ou ajuste para concluir o inventário.",
			},
			allItems: {
				title: "Todos os itens da categoria",
				description: "Itens que não passaram pela recontagem.",
			},
		},
		decision: {
			cancel: "Cancelar",
			approve: {
				title: "Aprovar inventário",
				bodyPrefix: "Você está aprovando a contagem de ",
				bodyHighlight_one: "{{count}} produto do estoque {{storage}}.",
				bodyHighlight_other: "{{count}} produtos do estoque {{storage}}.",
				confirmQuestion: "Tem certeza que deseja aprovar?",
				confirm: "Aprovar",
				success: "Inventário aprovado.",
				error: "Não foi possível aprovar o inventário.",
			},
			reject: {
				title: "Reprovar inventário",
				bodyPrefix: "Você está reprovando a contagem de ",
				bodyHighlight_one: "{{count}} produto do estoque {{storage}}.",
				bodyHighlight_other: "{{count}} produtos do estoque {{storage}}.",
				reasonLabel: "Justificativa",
				reasonPlaceholder: "Escreva o motivo da reprovação",
				reasonRequired: "Informe a justificativa",
				reasonMaxLength: "A justificativa deve ter no máximo {{maxLength}} caracteres",
				confirm: "Reprovar",
				success: "Inventário reprovado.",
				error: "Não foi possível reprovar o inventário.",
			},
		},
		notifications: {
			persistCountError: "Não foi possível salvar a contagem.",
			transferTypeError: "Erro ao atualizar ajuste/perda.",
		},
		error: {
			title: "Erro ao carregar o inventário",
			body: "Tente novamente em instantes.",
		},
		backToStorage: "Voltar para estoque",
	},
	deleteInventoryDialog: {
		title: "Deletar inventário?",
		warningMessagePrefix: "Tem certeza que deseja deletar o inventário ",
		warningMessageSuffix: "? Esta ação não pode ser desfeita.",
		fallbackName: "este inventário",
		submit: "Deletar inventário",
	},
};

export type InventoryV2Translations = typeof inventoryV2;
